import { render, staticRenderFns } from "./psuServicepayForm.vue?vue&type=template&id=11ad5256&scoped=true&"
import script from "./psuServicepayForm.vue?vue&type=script&lang=js&"
export * from "./psuServicepayForm.vue?vue&type=script&lang=js&"
import style0 from "./psuServicepayForm.vue?vue&type=style&index=0&id=11ad5256&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad5256",
  null
  
)

export default component.exports